module.exports = __webpack_public_path__ + "static/media/cw.3189e1c3.png";